import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[700px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">{contactData.title}</h2>
        <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg mx-auto">{contactData.description}</p>
        <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
          <a
            href="mailto:contact@taohua-video.com"
            className="flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            发送邮件
          </a>
          <div className="flex items-center gap-2 px-6 py-3 rounded-lg border border-background-200/60 text-foreground-400 text-sm whitespace-nowrap">
            <i className="ri-wechat-line text-secondary-400"></i>
            微信：taohua_official
          </div>
        </div>
      </div>
    </section>
  );
}